const ExpandableDevicesHighScoringTable = ({ data }) => {
    return (
        <>
            <article className="expandedComponentWrapper p-2">
                <p className={`fw-bold mb-3`}>
                    Congregation:{' '}
                    <span className="fw-normal">
                        {data?.group_name}
                    </span>
                </p>
                <p className={`fw-bold mb-3`}>
                    One Month Back Date:{' '}
                    <span className="fw-normal">
                        {data?.one_month_back_data}
                    </span>
                </p>
                <p className={`fw-bold mb-3`}>
                    Two Month Back Date:{' '}
                    <span className="fw-normal">
                        {data?.two_month_back_data}
                    </span>
                </p>
                <p className={`fw-bold mb-3`}>
                    Three Month Back Date:{' '}
                    <span className="fw-normal">
                        {data?.three_month_back_data}
                    </span>
                </p>
                <p className={`fw-bold mb-3`}>
                    Total Records:{' '}
                    <span className="fw-normal">{data?.total}</span>
                </p>
            </article>
        </>
    )
}

export default ExpandableDevicesHighScoringTable
